import { ContentCopy } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
} from "@mui/material";
import Header from "./Header";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { formatUnits, parseUnits } from "@ethersproject/units";
import { useStakingContract, useTokenContract } from "../../Connectivity/Hooks";
import { stakingContract as stakingAddress } from "../../Connectivity/environment";
import { AppContext } from "../../utils";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Footer from "../../Components/Footer";
import CopyToClipboard from "react-copy-to-clipboard";
import { useLocation } from "react-router-dom";
import moment from "moment";
import StakingModal from "./StakingModal";
import ReleaseModal from "./ReleaseModal";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import { useAccount, useSigner } from "wagmi";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    color: "#fff",
    border: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: "none",
    padding: "2px 16px",
  },
}));

const particleOptions = {
  autoPlay: true,
  background: {
    color: {
      value: "transparent",
      opacity: "0.2",
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onHover: {
        enable: true,
        mode: "grab",
      },
    },
    modes: {
      grab: {
        distance: 200,
        links: {
          opacity: 0.8,
        },
      },
    },
  },
  particles: {
    number: {
      value: 200,
    },
    color: {
      value: "#a0c8f0",
    },
    shape: {
      type: "polygon",
      polygon: {
        sides: 15,
      },
    },
    move: {
      // Enable particle movement
      enable: true,
      // Set the speed of particles
      speed: 2,
      // Enable particles to bounce off the edges
      bounce: true,
    },

    size: {
      value: 1, // Decrease the value to decrease particle size
      random: true, // Enable random size variation
      anim: {
        enable: false, // Disable size animation
        speed: 0, // Set animation speed to 0 (disabled)
        size_min: 0, // Set minimum size during animation
      },
    },
  },
};

const StakingUi = () => {
  const [amount, setAmount] = useState();
  const [Balance, setBalance] = useState("");
  const [claimed, setClaimed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [wamount, setWAmount] = useState();
  const [winAddress, setWinAddress] = useState([]);
  const [currentYeild, setCurrentYeild] = useState(null);
  const [pcomputingPower, setPcomputingPower] = useState("");
  const [computinLevel, setComputingLevel] = useState([]);
  const [nodeIncome, setNodeIncome] = useState("");
  const [prizePoolIncome, setPoolIncome] = useState("");
  const [comulativeincome, setComulativeIncome] = useState("");
  const [countdown, setCountdown] = useState(null);
  const [stakingOpenModal, setStakingOpenModal] = useState(false);
  const [releaseOpenModal, setReleaseOpenModal] = useState(false);
  const [error, setError] = useState(null);
  const [currentStekeNode, setCurrentStekeNode] = useState("");
  const [prizePool, setPrizePool] = useState("");
  const [buttonVisible, setButtonVisible] = useState(true);
  const [refferer, setReffrerer] = useState(null);
  const [claimErr, setClaimErr] = useState(null);
  const [loteryAmount, setLoteryAmount] = useState();
  const [checkPoint, setCheckPoint] = useState();
  const [weekTime, setWeekTime] = useState("");
  const [refDetails, setRefDetails] = useState([]);

  console.log(amount, "amount>>>>>>>>>1");

  useEffect(() => {
    let endTime;
    let intervalId = null;

    const startCountdown = () => {
      endTime = moment.unix(0).add(7, "days");

      intervalId = setInterval(() => {
        const now = moment();
        const diff = endTime.diff(now);

        if (diff <= 0) {
          endTime = moment.unix(weekTime).add(7, "days");
        }

        const duration = moment.duration(endTime.diff(now));
        const days = Math.max(Math.floor(duration.asDays()), 0);
        const hours = Math.max(duration.hours(), 0);
        const minutes = Math.max(duration.minutes(), 0);
        const seconds = Math.max(duration.seconds(), 0);

        setCountdown(
          `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`
        );
      }, 1000);
    };

    startCountdown();

    return () => {
      clearInterval(intervalId);
    };
  }, [weekTime]);

  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleCopy = () => {
    setAlertState({
      open: true,
      message: "Referral Link Copied",
      severity: "success",
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertState({
      ...alertState,
      open: false,
    });
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const refParam = searchParams.get("ref");

  const stakingHandleClose = () => {
    setStakingOpenModal(false);
  };
  const stakingHandleOpen = () => {
    setStakingOpenModal(true);
  };

  const releaseHandleClose = () => {
    setReleaseOpenModal(false);
  };

  const releaseHandleOpen = () => {
    setReleaseOpenModal(true);
  };

  const { connect, gasEstimationForAll } = useContext(AppContext);
  const { address: account } = useAccount();
  const { data: signer } = useSigner();

  const stakingContract = useStakingContract(signer);

  const tokenContract = useTokenContract(signer);
  const tokenContract1 = useTokenContract();
  const nuladress = "0x0000000000000000000000000000000000000000";

  const init = async () => {
    try {
      const currentWeek = await stakingContract.currentWeek();
      const weektime = await stakingContract.weekTime();
      const amounttodistribute = await stakingContract.amountToDistribute();
      const stakednodes = await stakingContract.currentStakedNodes();

      setCurrentStekeNode(stakednodes.toString());

      setLoteryAmount(formatUnits(amounttodistribute.toString(), 18));

      setWeekTime(weektime.toString());

      const { _users } = await stakingContract.getWeekData(
        +currentWeek.toString()
      );
      setWinAddress([..._users]);
      const refferData = [];
      for (const account of [..._users]) {
        const userInfo = await stakingContract.getUserInfo(account);
        refferData.push(userInfo._arr);
      }
      setRefDetails([...refferData]);
    } catch (error) {
      console.log(error, "init error");
    }
  };
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, account, currentStekeNode, refDetails, weekTime, winAddress]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getCurrentYeild = useCallback(async () => {
    if (account) {
      try {
        const decimals = await tokenContract1.decimals();
        const result = await stakingContract.getCurrentYield(account);
        // let currYeild = +result / 100000000;
        if (decimals) {
          let currYeildDecimals = decimals + 2;
          setCurrentYeild(formatUnits(result.toString(), currYeildDecimals));
        }
        setError(null);
      } catch (err) {
        setError(err.message);
      }
    }
  });

  const calculateRewards = async (i) => {
    try {
      const decimals = await tokenContract1.decimals();
      const claimedReward = await stakingContract.calculateReward(account, i);
      setClaimed(formatUnits(claimedReward.toString(), decimals));
      setClaimErr(null);
    } catch (err) {
      setClaimErr(err.message);
    }
  };

  useEffect(() => {
    getCurrentYeild();
  }, [getCurrentYeild]);

  const { t } = useTranslation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const inits = useCallback(async () => {
    try {
      const decimals = await tokenContract1.decimals();
      const balance = await tokenContract.balanceOf(account);
      setBalance(formatUnits(balance.toString(), decimals));

      const computingLevel = await stakingContract.getUserPower(account);
      setComputingLevel([...computingLevel]);

      // console.log(refferData, "refferData");

      const userInfo = await stakingContract.getUserInfo(account.toString());
      const {
        _nodes,
        _claimedReward,
        _claimablePrizePoolIncome,
        _referralsReward,
        _prizePoolIncome,
        _referrer,
        _checkpoint,
        _claimedReferralReward,
      } = userInfo;

      setPcomputingPower(_nodes.toString());
      setPoolIncome(formatUnits(_claimablePrizePoolIncome.toString(), 18));
      setNodeIncome(formatUnits(_referralsReward.toString(), decimals));
      setCheckPoint(+_checkpoint);
      setPrizePool(formatUnits(_prizePoolIncome.toString(), 18));
      setComulativeIncome(
        formatUnits(
          Number(_claimedReward) + Number(_claimedReferralReward),
          decimals
        )
      );

      if (refParam) {
        console.log(refParam, "refParam");
        setReffrerer(refParam);
      } else if (!refParam && !_referrer) {
        console.log("this is not a");
        setReffrerer(nuladress);
      } else {
        if ((_referrer === nuladress || !_referrer) && refParam) {
          setReffrerer(refParam);
        } else setReffrerer(_referrer);
      }

      calculateRewards(+_checkpoint);
    } catch (error) {
      console.error(error, "error resosn");
    } finally {
      console.log("done");
    }
  });

  useEffect(() => {
    inits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  const stakeHandler = async () => {
    const decimals = await tokenContract1.decimals();
    let decimalAllownce = decimals + 2;
    if (!account) {
      toast.error("Error! Please connect your wallet.");
    } else if (!amount) {
      toast.error("Error! Please enter a amount");
    } else if (amount <= 0) {
      toast.error("Error! Enter valid amount");
    } else {
      try {
        setLoading(true);
        setStakingOpenModal(false);
        setButtonVisible(false);

        let allowance = await tokenContract.allowance(account, stakingAddress);
        const Allowance = +formatUnits(allowance.toString(), decimalAllownce);

        if (Allowance < amount) {
          let getAmounts = Balance;
          const data1 = [
            stakingAddress,
            parseUnits(getAmounts.toString(), decimalAllownce),
          ];
          const fn1 = tokenContract.estimateGas.approve;
          const tx = await tokenContract.approve(
            stakingAddress,
            parseUnits(getAmounts.toString(), decimalAllownce),
            {
              gasLimit: gasEstimationForAll(account, fn1, data1),
            }
          );
          await tx.wait();

          toast.success("Success! Approved Confirmed.");
        }

        const fn = stakingContract.estimateGas.stake;
        let refAdd = refParam ? refParam : nuladress;

        const data = [refAdd, amount];

        const tx1 = await stakingContract.stake(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        setAmount("");
        await tx1.wait();

        toast.success("Success! Transaction Confirmed.");
        setLoading(false);
        setButtonVisible(true);
        init();
        inits();
        getCurrentYeild();
        calculateRewards();
      } catch (err) {
        setButtonVisible(true);
        setAmount("");
        if (err?.data?.message) {
          toast.error(err?.data?.message);
        } else if (err?.reason) {
          toast.error(err?.reason);
        } else {
          toast.error(err?.message);
        }
        setLoading(false);
      }
    }
  };

  const WithdrwaHandler = async (event) => {
    event.preventDefault();
    try {
      if (!account) {
        toast.error("Error! Please connect your wallet.");
      } else if (!wamount) {
        toast.error("Error! Please enter a amount");
      } else {
        setLoading(true);
        setReleaseOpenModal(false);
        const fn = stakingContract.estimateGas.withdraw;
        const data = [wamount.toString()];
        const tx = await stakingContract.withdraw(wamount.toString(), {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        setWAmount("");
        await tx.wait();
        toast.success("Success! Amount successfully Release.");

        inits();
        init();
        getCurrentYeild();
        calculateRewards();
        setLoading(false);
      }
    } catch (err) {
      setWAmount("");
      if (err?.data?.message) {
        toast.error(err?.data?.message);
      } else if (err?.reason) {
        toast.error(err?.reason);
      } else {
        toast.error(err?.message);
      }
      setLoading(false);
    }
  };

  const claimHandler = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const fn = stakingContract.estimateGas.claim;
      const data = [];

      const tx = await stakingContract.claim({
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      toast.success("Success! Amount successfully claimed.");
      inits();
      init();
      setLoading(false);
    } catch (err) {
      if (err?.data?.message) {
        toast.error(err?.data?.message);
      } else if (err?.reason) {
        toast.error(err?.reason);
      } else {
        toast.error(err?.message);
      }
      setLoading(false);
    }
  };

  // abovee

  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);

  return (
    <Box
      sx={{
        bgcolor: "#000",
        color: "#fff",
        height: "auto",
        pb: 4,
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particleOptions}
      />
      <Box>
        <Header />
        <StakingModal
          amount={amount}
          loading={loading}
          stakingHandleClose={stakingHandleClose}
          refParam={refParam}
          stakingOpenModal={stakingOpenModal}
          nuladress={nuladress}
          setAmount={setAmount}
          stakeHandler={stakeHandler}
          refferer={refferer}
        />
        <ReleaseModal
          WithdrwaHandler={WithdrwaHandler}
          releaseHandleClose={releaseHandleClose}
          setWAmount={setWAmount}
          wamount={wamount}
          releaseOpenModal={releaseOpenModal}
          pcomputingPower={pcomputingPower}
        />
        <Container>
          <Box
            py={5}
            background="#131213"
            borderRadius="20px"
            sx={{
              boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
            }}
            mt={5}
          >
            <Typography
              varaint="h3"
              sx={{
                fontSize: { xs: "20px", md: "36px" },
                fontWeight: "400",
                fontFamily: "Poppins",
                color: "#fff",
                textAlign: "center",
                mb: 2,
              }}
            >
              {t("StakingUi.head1")}
            </Typography>
            <Box
              display="flex"
              gap={2}
              flexWrap={"wrap"}
              alignItems="center"
              justifyContent="center"
              mt={1}
            >
              {account ? (
                <Link
                  sx={{
                    color: "#CB3C35",
                    fontSize: { md: "16px", xs: "12px", textAlign: "center" },
                  }}
                  href={`${window.location.origin}/staking/?ref=${account}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u> {window.location.origin + "/staking/?ref=" + account}</u>
                </Link>
              ) : (
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "#CB3C35",
                    border: "2px solid gray",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#CB3C35",
                    },
                  }}
                  onClick={() => connect()}
                >
                  {/* Connect your Wallet  */} {t("StakingUi.phead12")}
                </Button>
              )}
              <Stack spacing={2}>
                <CopyToClipboard
                  text={window.location.origin + "/staking/?ref=" + account}
                  onCopy={handleCopy}
                >
                  <IconButton
                    sx={{
                      cursor: "pointer",
                      color: "#CB3C35",
                      display: account ? "block" : "none",
                    }}
                  >
                    <ContentCopy />
                  </IconButton>
                </CopyToClipboard>

                <Snackbar
                  open={alertState.open}
                  autoHideDuration={3000}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                >
                  <Alert onClose={handleClose} severity={alertState.severity}>
                    {alertState.message}
                  </Alert>
                </Snackbar>
              </Stack>
            </Box>
          </Box>

          {/* Fy metaverse calculator ---------------------------------------------------------------------- */}

          <Box
            py={5}
            mt={6}
            borderRadius="20px"
            sx={{
              boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
            }}
            px={4}
          >
            <Typography
              sx={{
                fontSize: { xs: "15px", md: "25px" },
                fontWeight: "400",
                fontFamily: "Poppins",
                textAlign: "center",
              }}
            >
              {/* Actual Computing Power */}

              {t("StakingUi.head13")}
            </Typography>
            <Typography
              sx={{
                mt: 2,
                fontSize: { xs: "14px", md: "18px" },
                fontWeight: "400",
                fontFamily: "Poppins",
                textAlign: "center",
              }}
            >
              {currentStekeNode ? currentStekeNode : "0"}
            </Typography>
          </Box>

          {/* staking statistic ---------------------------------------------------------------------- */}

          <Box mt={10}>
            <Grid container spacing={4}>
              <Grid item xs={12} md={12}>
                <Box
                  py={5}
                  borderRadius="20px"
                  sx={{
                    boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
                  }}
                  px={4}
                  height="100%"
                  display="flex"
                  justifyContent="space-between"
                  flexDirection="column"
                >
                  <Box>
                    <Box display="flex" gap={1} alignItems="center">
                      <Box width="7px" height="30px" bgcolor="#CB3C35"></Box>
                      <Typography
                        sx={{
                          fontSize: { xs: "15px", md: "25px" },
                          fontWeight: "400",
                          fontFamily: "Poppins",
                        }}
                      >
                        {t("StakingUi.phead11")}
                      </Typography>
                    </Box>

                    <Box
                      display="flex"
                      justifyContent={"space-between"}
                      mt={2}
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", md: "15px" },
                          fontWeight: "400",
                          fontFamily: "Poppins",
                        }}
                      >
                        {/* yield */}
                        {t("StakingUi.head2")}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "15px", md: "20px" },
                          fontWeight: "500",
                          fontFamily: "Poppins",
                        }}
                      >
                        {pcomputingPower ? pcomputingPower : "0"}
                      </Typography>
                    </Box>

                    <Box
                      display="flex"
                      justifyContent={"space-between"}
                      mt={2}
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", md: "15px" },
                          fontWeight: "400",
                          fontFamily: "Poppins",
                        }}
                      >
                        Token {t("StakingUi.head3")}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "15px", md: "20px" },
                          fontWeight: "500",
                          fontFamily: "Poppins",
                        }}
                      >
                        {Balance ? Number(Balance).toFixed(0) : "0"}
                      </Typography>
                    </Box>

                    <Box
                      display="flex"
                      justifyContent={"space-between"}
                      mt={2}
                      alignItems="center"
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", md: "14px" },
                          fontWeight: "400",
                          fontFamily: "Poppins",
                        }}
                      >
                        {t("StakingUi.head4")}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", md: "16px" },
                          fontWeight: "500",
                          fontFamily: "Poppins",
                        }}
                      >
                        {error ? (
                          <Typography
                            sx={{
                              fontSize: { xs: "15px", md: "20px" },
                              fontWeight: "500",
                              fontFamily: "Poppins",
                            }}
                          >
                            0%
                          </Typography>
                        ) : currentYeild === null || NaN ? (
                          "0%"
                        ) : (
                          `${Number(currentYeild).toFixed(2)}%`
                        )}
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={6} display="flex" justifyContent="space-between">
                    <Button
                      sx={{
                        color: "white",
                        backgroundColor: "#CB3C35",
                        border: "2px solid gray",
                        borderRadius: "10px",
                        padding: "0.5rem 1rem",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#CB3C35",
                        },
                      }}
                      disabled={buttonVisible === false ? true : false}
                      onClick={stakingHandleOpen}
                    >
                      {/* Pledge  */} {t("StakingUi.phead13")}
                    </Button>

                    <Button
                      onClick={releaseHandleOpen}
                      sx={{
                        color: "white",
                        backgroundColor: "#CB3C35",
                        border: "2px solid gray",
                        borderRadius: "10px",
                        padding: "0.5rem 1rem",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#CB3C35",
                        },
                      }}
                    >
                      {/* Release */} {t("StakingUi.phead14")}
                    </Button>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box
                  py={5}
                  px={4}
                  borderRadius="20px"
                  sx={{
                    boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
                  }}
                  height="100%"
                >
                  <Box display="flex" gap={1} alignItems="center">
                    <Box width="7px" height="30px" bgcolor="#CB3C35"></Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "15px", md: "25px" },
                        fontWeight: "400",
                        fontFamily: "Poppins",
                      }}
                    >
                      {t("StakingUi.head5")}
                    </Typography>
                  </Box>

                  <Box>
                    <Box>
                      {computinLevel.length > 0 ? (
                        computinLevel?.map((item, i) => {
                          return (
                            <Box
                              key={i}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: { xs: "12px", md: "15px" },
                                  fontWeight: "400",
                                  fontFamily: "Poppins",
                                  mt: 2,
                                }}
                              >
                                {/* {t("StakingUi.head6")} */}
                                {t("StakingUi.lhead1")}
                                {i + 1}
                                {t("StakingUi.lhead2")}
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: { xs: "15px", md: "20px" },
                                  fontWeight: "500",
                                  fontFamily: "Poppins",
                                  mt: 2,
                                }}
                              >
                                {+item}
                              </Typography>
                            </Box>
                          );
                        })
                      ) : (
                        <Box>
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, i) => {
                            return (
                              <Box
                                display="flex"
                                justifyContent={"space-between"}
                                mt={2}
                                key={i}
                              >
                                <Typography
                                  sx={{
                                    fontSize: { xs: "12px", md: "15px" },
                                    fontWeight: "400",
                                    fontFamily: "Poppins",
                                    color: "#fff",
                                  }}
                                >
                                  {t("StakingUi.lhead1")}

                                  {i + 1}

                                  {t("StakingUi.lhead2")}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: { xs: "15px", md: "20px" },
                                    fontWeight: "500",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  0
                                </Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>

        {/* -------------------------modal */}

        <Container>
          <Box
            py={5}
            mt={10}
            borderRadius="20px"
            sx={{
              boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
            }}
            px={4}
            height="100%"
          >
            <Box display="flex" gap={1} alignItems="center">
              <Box width="7px" height="30px" bgcolor="#CB3C35"></Box>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "25px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {t("StakingUi.head7")}
              </Typography>
            </Box>

            <Box display="flex" justifyContent={"space-between"} mt={2}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {t("StakingUi.head12")}
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "20px" },
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                {claimErr
                  ? 0
                  : claimed === null
                  ? "0"
                  : `${Number(claimed).toFixed(2)}`}
              </Typography>
            </Box>

            <Box
              display="flex"
              justifyContent={"space-between"}
              alignItems="center"
              mt={2}
            >
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {t("StakingUi.head9")}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "20px" },
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                {nodeIncome ? Number(nodeIncome).toFixed(2) : 0}
              </Typography>
            </Box>

            <Box display="flex" justifyContent={"space-between"} mt={2}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {t("StakingUi.head10")}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "20px" },
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                {prizePoolIncome ? Number(prizePoolIncome).toFixed(2) : 0}
              </Typography>
            </Box>
            <Box display="flex" justifyContent={"space-between"} mt={2}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {t("StakingUi.head11")}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "20px" },
                  fontWeight: "500",
                  fontFamily: "Poppins",
                  textAlign: "right !important",
                }}
              >
                {comulativeincome ? Number(comulativeincome).toFixed(2) : 0}{" "}
                DSage
                <br />
                {prizePool ? Number(prizePool).toFixed(2) : 0} BNB
              </Typography>
            </Box>

            <Box mt={5} display="flex" justifyContent="center">
              {account ? (
                <Button
                  onClick={claimHandler}
                  disabled={
                    moment(checkPoint * 1000)
                      .add(1, "d")
                      .valueOf() > moment().valueOf()
                      ? true
                      : false
                  }
                  sx={{
                    color: "white",
                    backgroundColor: "#CB3C35",
                    border: "2px solid gray",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#CB3C35",
                    },
                  }}
                >
                  {/* Widthdraw proceed   */} {t("StakingUi.phead15")}
                </Button>
              ) : (
                <Button
                  onClick={connect}
                  sx={{
                    color: "white",
                    backgroundColor: "#CB3C35",
                    border: "2px solid gray",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#CB3C35",
                    },
                  }}
                >
                  {/* Widthdraw proceed   */} {t("StakingUi.phead10")}
                </Button>
              )}
            </Box>
          </Box>

          {/* --------------------prize polll */}
          <Box py={10}>
            <Typography
              sx={{
                fontSize: { xs: "20px", md: "36px" },
                fontWeight: "400",
                fontFamily: "Poppins",
                color: "#fff",
                textAlign: "center",
                mb: 2,
              }}
            >
              {t("StakingUi.phead1")}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "15px", md: "20px" },
                fontWeight: "300",
                fontFamily: "Poppins",
                color: "grey",
                textAlign: "center",
                mb: 2,
              }}
            >
              {/* Countdown to the lottery  */}
              {t("StakingUi.phead2")} : {loteryAmount ? loteryAmount : 0}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "15px", md: "20px" },
                fontWeight: "300",
                fontFamily: "Poppins",
                color: "grey",
                textAlign: "center",
                mb: 2,
              }}
            >
              {/* 13 days, 2 hours, 41 minutes and 55 seconds */}
              {/* {t("StakingUi.phead3")} */}

              {countdown
                ? countdown
                : " 0 days, 0 hours, 0 minutes and 0 seconds"}
            </Typography>
          </Box>

          <Box
            py={5}
            borderRadius="20px"
            sx={{ boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)" }}
            px={4}
            height="100%"
          >
            <Box display="flex" gap={1} alignItems="center">
              <Box width="7px" height="30px" bgcolor="#CB3C35"></Box>
              <Typography
                sx={{
                  fontSize: { xs: "15px", md: "25px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                }}
              >
                {/* Winners  */} {t("StakingUi.phead4")}
              </Typography>
            </Box>

            <TableContainer
              mt={5}
              sx={{
                overflow: "scroll",
                "&::-webkit-scrollbar": { width: "0px" },
              }}
            >
              <Table sx={{ border: "none" }}>
                <TableHead>
                  <TableRow sx={{ border: 0 }}>
                    <StyledTableCell
                      align="left"
                      sx={{ color: "#fff", minWidth: "150px" }}
                    >
                      {t("StakingUi.phead5")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      sx={{ color: "#fff", minWidth: "150px" }}
                    >
                      {t("StakingUi.phead16")}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      sx={{ color: "#fff", minWidth: "150px" }}
                    >
                      {t("StakingUi.phead17")} (Bnb)
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {winAddress.map((item, i) => {
                    const userRef = refDetails[i];
                    const amount =
                      loteryAmount *
                      [
                        0.25, 0.18, 0.14, 0.1, 0.08, 0.07, 0.06, 0.05, 0.04,
                        0.03,
                      ][i];

                    return (
                      <TableRow key={i} sx={{ border: 0, mt: 0 }}>
                        <StyledTableCell align="left">
                          <Box display="flex" gap={1}>
                            <Typography
                              sx={{
                                fontSize: { xs: "12px", md: "14px" },
                                fontWeight: "400",
                                fontFamily: "Poppins",
                                color: "#fff",
                                textAlign: "left",
                                marginBottom: "1.2rem",
                              }}
                            >
                              {i + 1}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: { xs: "12px", md: "14px" },
                                fontWeight: "400",
                                fontFamily: "Poppins",
                                color: "#fff",
                                textAlign: "left",
                                marginBottom: "1.2rem",
                              }}
                            >
                              {`${item?.slice(0, 6)}......${item?.slice(-6)}`}
                            </Typography>
                          </Box>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              color: "#fff",
                              marginBottom: "1.2rem",
                            }}
                          >
                            {userRef ? userRef[0].toString() : 0}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              fontWeight: "400",
                              fontFamily: "Poppins",
                              color: "#fff",
                              textAlign: "right",
                              marginBottom: "1.2rem",
                            }}
                          >
                            {item === nuladress ? 0 : amount.toFixed(5)} Bnb
                          </Typography>
                        </StyledTableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Container>

        <Footer />
      </Box>
    </Box>
  );
};

export default StakingUi;
